import React, { Component, Fragment, PureComponent, useState } from 'react'
import { Button, Icon, Popup } from 'semantic-ui-react'
import DataTable from '../datatable'
import { deleteFile } from './actions'
import Upload from './upload'
//import FileEdit from './views/edit'

const accessLabels = {
  private: 'Yksityinen',
  public: 'Julkinen',
}
/*
class OpenFileEdit extends Component {
  state = {
    isEditing: false,
  }
  componentDidMount = () => {}

  fileEdit(i) {
    this.setState({ isEditing: false })
  }

  render() {
    console.log(this.props)
    return (
      <div>
        {this.state.isEditing ? (
          <FileEdit
            file={this.props.file}
            onClose={() => {
              this.fileEdit(false)
            }}></FileEdit>
        ) : (
          <Button
            onClick={e => {
              e.preventDefault()
              this.setState({ isEditing: true })
            }}>
            Edit
          </Button>
        )}
      </div>
    )
  }
}
*/
class DeletePrompt extends Component {
  state = {
    isOpen: false,
    isSuccess: false,
  }

  componentDidMount = () => {}

  deleteFileFunc(id) {
    deleteFile(id)
      .then(success => {
        this.setState({ isSuccess: true })
      })
      .catch(error => {})
  }

  isSuccessDelete(err, data) {
    console.log(err, data)
    if (err !== null) {
    } else {
    }
  }

  render() {
    let deleteTrigger = (
      <a href="#" className="button-plain" onClick={e => e.preventDefault() & this.setState({ isOpen: true })}>
        Poista
      </a>
    )
    let deleteContent = (
      <div className="prompt">
        <b>Oletko varma?</b>
        <div className="prompt-button">
          <Button
            size="tiny"
            content="Kyllä"
            onClick={e => e.preventDefault() & this.deleteFileFunc(this.props.fileId)}
            color="red"
          />
        </div>
      </div>
    )

    let successContent = (
      <div className="prompt">
        <b>Poistettu</b>
        <div className="prompt-button">
          <Button
            size="tiny"
            content="x"
            onClick={e => e.preventDefault() & this.setState({ isOpen: false })}
            color="red"
          />
        </div>
      </div>
    )
    return (
      <Popup
        trigger={deleteTrigger}
        content={this.state.isSuccess ? successContent : deleteContent}
        open={this.state.isOpen}
        on="click"
        position="top right"
      />
    )
  }
}

const columns = [
  {
    name: 'filename',
    label: 'Tiedostonimi',
    sortable: true,
  },
  // { name: 'foldername', label: 'Kansio', sortable: true, width: 200, searchable: true, defaultSort: true },
  {
    name: 'url',
    label: 'URL',
    render(i) {
      return (
        <a href={i.get('url')} target="_blank">
          <Icon name="download" />
          Lataa tiedosto
        </a>
      )
    },
  },
  {
    name: 'access',
    label: 'Pääsy',
    render(i) {
      return i.get('access')
    },
  },
  {
    name: 'created_at',
    label: 'Aika',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
    defaultSort: true,
  },
  {
    name: 'fileId',
    label: '',
    render(i) {
      return <DeletePrompt fileId={i.get('id')} />
    },
  },
  /*
  {
    name: 'fileEdit',
    label: '',
    render(i) {
      return <OpenFileEdit file={i}></OpenFileEdit>
    },
  },
  */
]

export default class FileRoot extends Component {
  state = {
    open: false,
  }
  render() {
    let { open } = this.state

    return (
      <Fragment>
        <DataTable
          id="files"
          entity="file"
          sortDir="desc"
          title="Tiedostot"
          actions={[
            { text: 'Lataa tiedostoja', icon: 'upload', action: () => this.setState({ open: open === false }) },
          ]}
          columns={columns}>
          {open ? (
            <div className="datatable-action datatable-action--upload">
              <Upload multiple />
            </div>
          ) : null}
        </DataTable>
      </Fragment>
    )
  }
}
